<script setup lang="ts">
import { Library } from 'lucide-vue-next'
import NavigationFilterButton from './NavigationFilterButton.vue'
import CreateElementDrawer from './CreateElementDrawer.vue'
import UserMenuDrawer from './UserMenuDrawer.vue'
import { useNavigationData } from '~~/src/composables/useNavigationData'

defineOptions({
  name: 'AppBottomBarMobile',
})

const route = useRoute()
const { getNavigationItems, getCreateItems } = useNavigationData()

const navigationItems = getNavigationItems()
const createItems = getCreateItems()

const isLibraryActive = computed(() => route.path === '/library')
</script>

<template>
  <div class="bottom-bar-mobile">
    <div class="bottom-bar-content">
      <!-- User Menu -->
      <UserMenuDrawer />

      <!-- First 2 navigation items -->
      <NavigationFilterButton
        v-for="item in navigationItems.slice(0, 2)"
        :key="item.href"
        :item="item"
      />

      <!-- Center - Create Button -->
      <CreateElementDrawer :create-items="createItems" />

      <!-- Last 2 navigation items -->
      <NavigationFilterButton
        v-for="item in navigationItems.slice(2, 4)"
        :key="item.href"
        :item="item"
      />

      <!-- Library Button -->
      <a
        href="/library"
        class="nav-button"
        :class="{ 'is-active': isLibraryActive }"
        aria-label="Library"
      >
        <Library
          :size="20"
          :class="isLibraryActive ? 'text-gray-900' : 'text-gray-600'"
        />
      </a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.bottom-bar-mobile {
  @apply
    fixed
    bottom-0
    left-0
    right-0
    z-50
    bg-white
    border-t
    border-gray-200
    md:hidden;
}

.bottom-bar-content {
  @apply
    flex
    items-center
    justify-evenly
    px-3
    py-2
    h-16;
}

.nav-button {
  @apply
    flex
    items-center
    justify-center
    h-10
    w-10
    p-0
    rounded-md
    hover:bg-gray-100
    transition-colors
    duration-200
    shrink-0;

  &.is-active {
    @apply bg-gray-100;
  }
}
</style>
